<script setup lang="ts">
import { ModalConfirmation } from '@shared/ui/modals'

import { useModalCustomerDelete } from '../../model/modal-customer-delete.hook'

defineOptions({
  name: 'ModalCustomerDelete',
})

const {
  refIsOpen,
  refIsLoading,
  closeModal,
  confirmDelete,
} = useModalCustomerDelete()
</script>

<template>
  <ModalConfirmation
    :show="refIsOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="delete"
    title="Delete customer?"
    detail="Are you sure you want to delete this customer? All of data will be permanently removed. This action cannot be uncompleted."
    button-title="Delete customer"
    @click:confirm="confirmDelete"
    @click:cancel="closeModal"
  />
</template>
